import { getBrand, getSiteUrl } from '@/lib/brands'

/**
 * Valores de marca que rellenan los placeholders `{brand}`, `{supportEmail}` y
 * `{siteUrl}` de `locales/` (ADR-035). Se resuelven en cada llamada: la marca
 * se lee de la env y los tests la cambian con `vi.stubEnv`.
 */
export type BrandValues = { brand: string; supportEmail: string; siteUrl: string }

export function brandValues(): BrandValues {
  const brand = getBrand()
  return { brand: brand.name, supportEmail: brand.supportEmail, siteUrl: getSiteUrl() }
}

const TOKEN = /\{(brand|supportEmail|siteUrl)\}/g

function fillBrand(text: string, values: BrandValues): string {
  // Función de reemplazo: un valor con `$&`/`$1` no se interpreta como patrón.
  return text.replace(TOKEN, (_match, key: keyof BrandValues) => values[key])
}

function fillTree<T>(node: T, values: BrandValues): T {
  if (typeof node === 'string') return fillBrand(node, values) as T
  if (Array.isArray(node)) return node.map((item) => fillTree(item, values)) as T
  if (node && typeof node === 'object') {
    return Object.fromEntries(Object.entries(node).map(([k, v]) => [k, fillTree(v, values)])) as T
  }
  return node
}

/**
 * Copia profunda de un árbol de mensajes (cadena, array u objeto) con los tokens
 * de marca rellenos. Resuelve la marca UNA vez por llamada. Es el único punto
 * donde next-intl ve la marca: `i18n/request.ts` y el loader del árbol
 * autenticado la aplican, así ningún `t()`/`t.raw()` cambia de firma.
 */
export function brandMessages<T>(messages: T): T {
  return fillTree(messages, brandValues())
}
